import { Node, mergeAttributes } from "@tiptap/core";
import { serializeSkillMentionToken } from "@quake/isomorphic/skill-mentions";
import { skillMentionClassName } from "../skill-mention-badge";

export const SkillMention = Node.create({
  name: "skillMention",
  group: "inline",
  inline: true,
  atom: true,
  selectable: true,
  addAttributes() {
    return {
      id: { default: "", parseHTML: (element) => element.getAttribute("data-skill-id") },
      label: { default: "", parseHTML: (element) => element.getAttribute("data-skill-label") },
    };
  },
  parseHTML() {
    return [{ tag: 'span[data-type="skill-mention"]' }];
  },
  renderText({ node }) {
    return serializeSkillMentionToken({ id: node.attrs.id, label: node.attrs.label });
  },
  renderHTML({ node, HTMLAttributes }) {
    return [
      "span",
      mergeAttributes(HTMLAttributes, {
        "data-type": "skill-mention",
        "data-skill-id": node.attrs.id,
        "data-skill-label": node.attrs.label,
        contenteditable: "false",
        class: skillMentionClassName,
      }),
      [
        "http://www.w3.org/2000/svg svg",
        {
          width: "12",
          height: "12",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "aria-hidden": "true",
        },
        [
          "http://www.w3.org/2000/svg path",
          {
            d: "m12 3 1.912 5.813a2 2 0 0 0 1.275 1.275L21 12l-5.813 1.912a2 2 0 0 0-1.275 1.275L12 21l-1.912-5.813a2 2 0 0 0-1.275-1.275L3 12l5.813-1.912a2 2 0 0 0 1.275-1.275L12 3Z M5 3v4 M3 5h4 M19 17v4 M17 19h4",
          },
        ],
      ],
      node.attrs.label || node.attrs.id,
    ];
  },
});
